import { SvgIcon, SvgIconProps } from '../SvgIcon/SvgIcon';
export * from './ArrowDownLeftIcon';

export const Torso = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="-1 -1 14 14">
    <path
      stroke="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.902096 8.32544C1.47595 7.79453 2.24949 7.5 3.05147 7.5H8.94853C9.75051 7.5 10.5241 7.79453 11.0979 8.32544C11.6725 8.85709 12 9.58312 12 10.3452V11.5357C12 11.7921 11.786 12 11.5221 12C11.2581 12 11.0441 11.7921 11.0441 11.5357V10.3452C11.0441 9.84442 10.8293 9.35925 10.4387 8.99786C10.0473 8.63574 9.51163 8.42857 8.94853 8.42857H3.05147C2.48837 8.42857 1.95273 8.63574 1.56132 8.99786C1.17071 9.35925 0.955882 9.84442 0.955882 10.3452V11.5357C0.955882 11.7921 0.741901 12 0.477941 12C0.213982 12 0 11.7921 0 11.5357V10.3452C0 9.58312 0.327452 8.85709 0.902096 8.32544Z"
      fill="currentColor"
    />
    <path
      stroke="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 1.06849C4.93326 1.06849 4.06849 1.93326 4.06849 3C4.06849 4.06674 4.93326 4.93151 6 4.93151C7.06674 4.93151 7.93151 4.06674 7.93151 3C7.93151 1.93326 7.06674 1.06849 6 1.06849ZM3 3C3 1.34315 4.34315 0 6 0C7.65685 0 9 1.34315 9 3C9 4.65685 7.65685 6 6 6C4.34315 6 3 4.65685 3 3Z"
      fill="currentColor"
    />
  </SvgIcon>
);
